import {ApplicationConfig, isDevMode, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {provideHttpClient} from "@angular/common/http";
import {provideTranslateService} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {LobbyStore} from "./store/lobby.store";
import {PlayerStore} from "./store/player.store";
import {GameStateStore} from "./store/game-state.store";
import {provideServiceWorker} from '@angular/service-worker';
import {GameSettingsStore} from "./store/game-settings.store";
import {MAT_CARD_CONFIG} from "@angular/material/card";
import {RoomStore} from "./store/room.store";
import {AppSettingsStore} from "./store/app-settings.store";
import {ConfirmationStore} from "./store/confirmation.store";
import {YoutubePlayerStore} from "./store/youtube-player.store";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
    RoomStore,
    LobbyStore,
    PlayerStore,
    GameStateStore,
    GameSettingsStore,
    AppSettingsStore,
    ConfirmationStore,
    YoutubePlayerStore,
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: MAT_CARD_CONFIG,
      useValue: {
        appearance: 'outlined'
      }
    }
  ]
};
